// c:/xampp/htdocs/miners-market-main/components/forms/RentalForm.js

import AccordionSection from '../AccordionSection.jsx';
import MediaManager from './MediaManager.jsx';

function RentalForm({ formData, onFormChange, openSection, onToggleSection }) {
    return (
        <div className="space-y-2">
            <AccordionSection title="1. Rental Details" id="rentalDetails" openSection={openSection} onToggle={onToggleSection}>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Equipment Type*</label>
                    <input type="text" name="equipment_type" value={formData.equipment_type || ''} onChange={onFormChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Equipment Description</label>
                    <textarea 
                        name="description" 
                        value={formData.description || ''} 
                        onChange={onFormChange} 
                        rows="3" 
                        className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
                    ></textarea>
                </div>
                <div className="grid md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Equipment Size</label>
                        <input type="text" name="size" value={formData.size || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Rate (R/hour)*</label>
                        <input type="text" name="rate_per_hour" value={formData.rate_per_hour ?? ''} onChange={onFormChange} required className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Minimum Hire Duration</label>
                    <input type="text" name="min_hire_duration" value={formData.min_hire_duration || '6 months'} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                </div>
            </AccordionSection>

            <AccordionSection title="2. Images" id="images" openSection={openSection} onToggle={onToggleSection}>
                <MediaManager formData={formData} onFormChange={onFormChange} />
            </AccordionSection>

            <AccordionSection title="3. Contact Information" id="contactInfo" openSection={openSection} onToggle={onToggleSection}>
                <div className="grid md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Sales Contact Name</label>
                        <input type="text" name="sales_contact_name" value={formData.sales_contact_name || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Sales Contact Phone</label>
                        <input type="tel" name="sales_contact_phone" value={formData.sales_contact_phone || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                </div>
                <div className="grid md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Sales Contact Email</label>
                        <input type="email" name="sales_contact_email" value={formData.sales_contact_email || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Company Name & Address</label>
                        <input type="text" name="company_name_address" value={formData.company_name_address || ''} onChange={onFormChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                    </div>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">Support Contact Details</label>
                    <textarea name="support_contact_details" value={formData.support_contact_details || ''} onChange={onFormChange} rows="3" className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" placeholder="e.g., Technical support line, email, or website"></textarea>
                </div>
            </AccordionSection>
        </div>
    );
}

export default RentalForm;
